module.exports = __webpack_public_path__ + "img/banner-enablesi-m.8e4791b1.png";